// @flow

import { connect } from "react-redux";

import Title from "src/components/chatroom/Title/Edit";
import { setAttribute } from "src/actions/chatroom";
import {
  getChatroomType,
  getChatroomTitle,
  getSequenceNo,
  getCanceled,
  getTemplateId
} from "src/reducers";

import type { AppState } from "src/types";

const mapStateToProps = ({ app }: { app: AppState }, props) => ({
  type: getChatroomType(app, props.roomId),
  templateId: getTemplateId(app, props.roomId),
  title: getChatroomTitle(app, props.roomId),
  seqNo: getSequenceNo(app, props.roomId),
  canceled: getCanceled(app, props.roomId)
});

export default connect(mapStateToProps, { setAttribute })(Title);
